import { CollectionFilters, QueryResult } from '@/type';
import { PostImport } from '@/social/types';
import api from '../../API';

export default {
  async find(id: number): Promise<PostImport> {
    return api
      .get(`post-imports/${id}`)
      .then(response => response.data);
  },
  findAll(
    socialAccountId: number,
    filters: CollectionFilters,
  ): Promise<QueryResult<PostImport>> {
    return api
      .get(`social-accounts/${socialAccountId}/post-imports`, { params: filters })
      .then(response => response.data);
  },
};
